'use client';
import axios, { AxiosRequestConfig } from 'axios';

import { responseInterceptorOnErrorV2 } from './errorInterceptorV2';
import { responseParser } from './responseParser';
import {
  API_ENDPOINT_NEST,
  API_PAYMENT_ENDPOINT,
} from '@wwe-portal/web/utils/config';

const DEFAULT_TIMEOUT = 30000;

export const nestApiClient = axios.create({
  withCredentials: true,
  baseURL: API_ENDPOINT_NEST,
});

export const authRequestInterceptor = (config: AxiosRequestConfig) => {
  return config;
};

nestApiClient.interceptors.response.use(
  responseParser,
  responseInterceptorOnErrorV2
);

export const paymentAPiClient = axios.create({
  withCredentials: true,
  baseURL: API_PAYMENT_ENDPOINT,
  timeout: DEFAULT_TIMEOUT,
});
paymentAPiClient.interceptors.response.use(
  responseParser,
  responseInterceptorOnErrorV2
);
